export default "__VITE_ASSET__DfKUOSlU__"